import { render, staticRenderFns } from "./ResourceBtn.vue?vue&type=template&id=a892b48e&scoped=true&"
import script from "./ResourceBtn.vue?vue&type=script&lang=js&"
export * from "./ResourceBtn.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBtn.vue?vue&type=style&index=0&id=a892b48e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a892b48e",
  null
  
)

export default component.exports